import { render, staticRenderFns } from "./DashboardComp.vue?vue&type=template&id=7955c7f4"
import script from "./DashboardComp.vue?vue&type=script&lang=js"
export * from "./DashboardComp.vue?vue&type=script&lang=js"
import style0 from "./DashboardComp.vue?vue&type=style&index=0&id=7955c7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports